import {
  Divider,
  Dropdown,
  Form,
  Input,
  InputNumber,
  message,
  Spin,
  Table,
  TimePicker,
  Tooltip,
} from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import svg10 from "../../assets/svg/svg10.svg";
import svg20 from "../../assets/svg/svg20.svg";
import svg21 from "../../assets/svg/svg21.svg";
import svg15 from "../../assets/svg/svg15.svg";
import svg26 from "../../assets/svg/svg26.svg";
import svg1 from "../../assets/svg/svg1.svg";
import svg29 from "../../assets/svg/svg29.svg";
import svg8 from "../../assets/svg/svg8.svg";
import TableLoading from "../../components/TableLoading";
import { check, getFilenameFromHeaders } from "../../utils";
import { save, saveArray } from "../../features/save/saveSlice";
import toast from "react-hot-toast";
import useModalToggle from "../../custom_hooks/useModalToggle";
import ConfirmModal from "../../components/ConfirmModal";
import { downloadExcel, fetchData } from "../../features/fetch/fetchSlice";
import DocumentTableAdd from "../excel-upload/DocumentTableAdd";

const EditableCell = ({
  editing,
  dataIndex,
  title,
  inputType,
  record,
  index,
  children,
  originalValues,
  dataSource,
  setTableData,
  ...restProps
}) => {
  const originalValue = originalValues?.[record?.tdId]?.[dataIndex];
  const handleChange = (value, type) => {
    let newValue;

    if (type === "money") {
      newValue = value;
    } else if (type === "time") {
      newValue = value ? value.format("HH:mm") : null;
    } else {
      newValue = value?.target?.value ?? "";
    }

    const newData = dataSource?.map((row) =>
      row.tdId === record.tdId ? { ...row, [dataIndex]: newValue } : row
    );

    setTableData(newData);
    check(record.ppId, newData, setTableData, dataIndex);
    // check(record.ppId, newData, setTableData);
  };

  const inputNode =
    inputType === "time" ? (
      <TimePicker format="HH:mm" className="w-full input" id="input-focus" />
    ) : inputType === "money" ? (
      <InputNumber
        min={0}
        id="input-focus"
        className="input flex"
        variant="borderless"
        style={{ width: "100%" }}
        onChange={(val) => handleChange(val, "money")}
      />
    ) : (
      <Input
        id="input-focus"
        className="input"
        placeholder={`Enter ${title}`}
      />
    );

  return (
    <td {...restProps}>
      {editing ? (
        <div className="flex items-center gap-2">
          <Form.Item
            className="table-form-item"
            name={dataIndex}
            style={{ margin: 0 }}
            rules={[
              {
                required: true,
                message: `${title} is required`,
              },
            ]}
          >
            {inputNode}
          </Form.Item>

          {originalValue !== undefined && (
            <Tooltip title={`Previous value: ${originalValue}`} trigger="click">
              <img
                src={svg15}
                alt="svg15"
                className="cursor-pointer text-blue-600"
              />
            </Tooltip>
          )}
        </div>
      ) : (
        children
      )}
    </td>
  );
};

export default function DataSetTable({
  columns,
  dataSource,
  setTableData,
  originalData,
}) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const { loading, downloadLoading } = useSelector((state) => state.fetch);
  const { user } = useSelector((state) => state.auth);
  const { filterObj, selectedLeaf, saving } = useSelector((state) => ({
    filterObj: state.obj.filterObj,
    selectedLeaf: state.obj.selectedLeaf,
    saving: state.save.saving,
  }));
  const [editingKey, setEditingKey] = useState("");
  const isEditing = (record) =>
    record?.tdId === editingKey && record?.ppIseditable;

  const [originalValues, setOriginalValues] = useState({});

  const edit = (record) => {
    setOriginalValues((prev) => ({
      ...prev,
      [record?.tdId]: { ...record },
    }));

    form.setFieldsValue({
      ...record,
    });
    setEditingKey(record?.tdId);
  };

  const cancel = () => {
    setEditingKey("");
  };

  const saveFunction = async (key) => {
    try {
      const row = await form.validateFields();
      const newData = [...dataSource];
      const index = newData.findIndex((item) => key === item?.tdId);

      if (index > -1) {
        const item = newData[index];
        const updatedObj = {
          ...item,
          ...row,
        };
        newData.splice(index, 1, updatedObj);
        setEditingKey("");
        setTableData(newData);
        // console.log("Saved successfully:", updatedObj);
        // TODO: optionally dispatch an action or callback to update parent data
      }
    } catch (errInfo) {
      console.log("Validate Failed:", errInfo);
    }
  };

const mergedColumns = columns?.map((col) => {
  if (!col.editable) {
    return {
      ...col,
      width: col.width || 150, // Set default width
      ellipsis: {
        showTitle: true, // Show tooltip on hover
      },
    };
  }
  return {
    ...col,
    width: col.width || 150, // Set default width
    ellipsis: {
      showTitle: true, // Show tooltip on hover
    },
    onCell: (record) => ({
      record,
      dataIndex: col.dataIndex,
      inputType: ["tdValue", "tdM1Value", "tdM2Value", "tdM3Value"].includes(
        col.dataIndex
      )
        ? "money"
        : "text",
      title: col.title,
      editing: isEditing(record),
      originalValues: originalData?.reduce((acc, item) => {
        acc[item?.tdId] = item;
        return acc;
      }, {}),
      dataSource,
      setTableData,
    }),
  };
});

  const { open, handleCancel, handleOpen } = useModalToggle();
  const [prodd, setProdd] = useState();
  const [openDocAdd, setOpenDocAdd] = useState();
  const handleOpenDocAdd = async (item) => {
    await setProdd(item);
    await setOpenDocAdd(true);
  };
  const handleCancelDocAdd = async () => {
    setOpenDocAdd(false);
  };
  const handleOpenConfirmation = () => {
    handleOpen();
  };

  async function handleUpdate() {
    const formParams = [];

    dataSource?.forEach((row) => {
      formParams?.push(
        `txt_${row?.tdId}=${encodeURIComponent(row?.tdValue ?? "")}`
      );
      if (row?.tdM1Value !== undefined) {
        formParams?.push(
          `txt_M1_${row?.tdId}=${encodeURIComponent(row?.tdM1Value ?? "")}`
        );
      }
      if (row?.tdM2Value !== undefined) {
        formParams?.push(
          `txt_M2_${row?.tdId}=${encodeURIComponent(row?.tdM2Value ?? "")}`
        );
      }
      if (row?.tdM3Value !== undefined) {
        formParams?.push(
          `txt_M3_${row?.tdId}=${encodeURIComponent(row?.tdM3Value ?? "")}`
        );
      }

      if (row?.tdNumberValue !== undefined) {
        formParams?.push(
          `numberfield-${row?.tdId}-inputEl=${encodeURIComponent(
            row?.tdNumberValue ?? ""
          )}`
        );
      }

      formParams?.push(
        `tdRev_${row?.tdId}=${encodeURIComponent(row?.tdRev ?? "")}`
      );
    });

    const baseRow = dataSource?.[0];
    if (baseRow) {
      formParams?.push(
        `v_pageType=${encodeURIComponent(filterObj?.fsType ?? "")}`
      );
      formParams?.push(`v_month=${encodeURIComponent(filterObj?.month ?? "")}`);
      formParams?.push(`tdWspId=74`);

      formParams?.push(
        `cmDatasetDtlId=${encodeURIComponent(baseRow?.tdDatasetDtlsId ?? "")}`
      );
      formParams?.push(
        `tdDatasetDtlsId=${encodeURIComponent(baseRow?.tdDatasetDtlsId ?? "")}`
      );
      formParams?.push(`ppName=${encodeURIComponent(baseRow?.tdPName ?? "")}`);
      formParams?.push(
        `v_Method_Id=${encodeURIComponent(baseRow?.tdMethod ?? "")}`
      );
      formParams?.push(
        `tdMethod=${encodeURIComponent(baseRow?.tdMethod ?? "")}`
      );

      const keyValue =
        baseRow?.tdMethod === "SCHEME"
          ? selectedLeaf?.scId
          : baseRow?.tdMethod === "ZONE"
          ? selectedLeaf?.znId
          : null;

      formParams?.push(`v_key=${encodeURIComponent(keyValue ?? "")}`);
      formParams?.push(`tdKeyValue=${encodeURIComponent(keyValue ?? "")}`);
      formParams?.push(
        `cmComment=${encodeURIComponent(baseRow?.cmComment ?? "null")}`
      );
    }

    const payload = formParams?.join("&");

    const res = await dispatch(
      saveArray({
        url: `api/v2/public/saveFormGenerate?v_tdYear=${filterObj?.code}`,
        data: payload,
      })
    );

    if (res?.payload?.success) {
      await toast.success(res?.payload?.message?.message);
      await dispatch(
        fetchData({
          url: "api/v2/public/fetchFormGenerate",
          pgName_id: selectedLeaf?.title ?? selectedLeaf?.subTitle,
          v_wsp_id: "74",
          v_tdYear: filterObj?.code,
          v_tdQtr: filterObj?.quarter,
          v_mnCode: filterObj?.month,
          scId: selectedLeaf?.scId || null,
          znId: selectedLeaf?.znId || null,
          datasetDtls_id: filterObj?.datasetDtls_id || null,
          pDataRqType: filterObj?.fsType,
        })
      ).then((res) => {
        setTableData(res.payload?.data || []);
      });
      await handleCancel();
    } else {
      toast.error(res?.payload?.message?.message);
    }
  }
//  tdDatasetDtlsId
  const [downloadingId, setDownloadingId] = useState(null);

  const handleDownload = async (item) => {
    setDownloadingId(item?.tdId);
    const res = await dispatch(
      downloadExcel({
        url: `api/v1/files/download?td_id=${item?.tdId}`,
      })
    );

    setDownloadingId(null);

    if (res?.payload?.headers && res?.payload?.data) {
      const blobData = res.payload.data;
      const headers = res.payload.headers;

      const contentType = headers["content-type"] || "application/octet-stream";
      const fileName = getFilenameFromHeaders(headers, "c2b_transactions");

      const blob = new Blob([blobData], { type: contentType });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();

      link.remove();
      window.URL.revokeObjectURL(url);

      toast.success(`${fileName} downloaded successfully`);
    } else {
      console.error("Download failed response:", res?.payload);

      let errorMessage = "Failed to download file";
      if (res?.payload && typeof res.payload === "object") {
        errorMessage = Object.values(res.payload)[0] || errorMessage;
      }
      toast.error(errorMessage);
    }
  };

  const isRowLoading = (record) =>
    downloadLoading && downloadingId === record?.tdId;

  const handleExport = async () => {
    const res = await dispatch(
      downloadExcel({
        url: `api/v1/upload/exportXlsx?datasetDtls_id=${dataSource?.[0]?.tdDatasetDtlsId}`,
      })
    );

    if (res?.payload?.headers && res?.payload?.data) {
      const blobData = res.payload.data;
      const headers = res.payload.headers;

      const contentType = headers["content-type"] || "application/octet-stream";
      const fileName = getFilenameFromHeaders(headers, "c2b_transactions");

      const blob = new Blob([blobData], { type: contentType });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();

      link.remove();
      window.URL.revokeObjectURL(url);

      toast.success(`${fileName} downloaded successfully`);
    } else {
      console.error("Download failed response:", res?.payload);

      let errorMessage = "Failed to download file";
      if (res?.payload && typeof res.payload === "object") {
        errorMessage = Object.values(res.payload)[0] || errorMessage;
      }
      toast.error(errorMessage);
    }
  };

  const [openFill, setOpenFill] = useState(false);
  const handleOpenFill = async () => {
    await setOpenFill(true);
  };
  const handleCancelFill = async () => {
    await setOpenFill(false);
  };

  const handleFill = async (data) => {
    const res = await dispatch(
      save({
        dscdId: dataSource?.[0]?.tdDatasetDtlsId,
        scope:filterObj?.fsType,
        month:filterObj?.month,
        url: "api/v1/autofill/autofill",

      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.messages?.message);
      await form.resetFields();
      await handleCancelFill();
    } else {
      toast.error(res?.payload?.messages?.message);
    }
  };

  const settingItems = [
    {
      key: "1",
      label: (
        <Link
          onClick={handleExport}
          className="flex gap-x-[.75rem] items-center py-[.5rem] font-dmSans"
        >
          <img src={svg8} alt="svg8" className="w-4 h-4" />
          <span className="whitespace-nowrap">Export</span>
        </Link>
      ),
    },
    {
      key: "divider-1",
      type: "divider",
    },
    {
      key: "2",
      label: (
        <Link
          onClick={handleOpenFill}
          className="flex gap-x-[.75rem] items-center py-[.5rem] font-dmSans"
        >
          <img src={svg29} alt="svg29" className="w-4 h-4" />
          <span className="whitespace-nowrap">Autofill</span>
        </Link>
      ),
    },
  
  ];
// console.log("filterObj",filterObj)

  if (loading) return <TableLoading />;
  return (
    <>
      <div className="h-[70vh] flex flex-col">
        <div
          style={{
            position: "sticky",
            top: 0,
            background: "white",
            zIndex: 1000,
          }}
        >
          <div className="flex lg:flex-row flex-col lg:items-center justify-between lg:gap-0 gap-5">
            <span className="text-[#2D3E8D] text-[1.5rem] font-[600]">
              {filterObj?.fsType && (
                <span className="font-medium">
                  {filterObj?.code ? `${filterObj.code} - ` : ""}
                  {filterObj?.fsType.charAt(0).toUpperCase() +
                    filterObj?.fsType.slice(1)}
                  {filterObj?.fsType === "MONTHLY" && filterObj?.month
                    ? `: (${filterObj?.month})`
                    : filterObj?.fsType === "QUARTERLY" && filterObj?.quarter
                    ? `: (${filterObj?.quarter})`
                    : ""}{" "}
                  – {selectedLeaf?.title} ({selectedLeaf?.subTitle})
                </span>
              )}
            </span>
            <div className="flex lg:gap-[1rem] items-center">
              <div className="w-[120px]">
                <button
                  className="cstm-btn !border-none !bg-white !text-[#706F6F] !text-[1rem] !font-[400]"
                  type="button"
                  onClick={handleOpenConfirmation}
                >
                  <img src={svg26} alt="svg26" /> Update
                </button>
              </div>

                <Dropdown
                  overlayStyle={{
                    width: "180px",
                  }}
                  trigger={"click"}
                  menu={{ items: settingItems }}
                  placement="bottom"
                  className="bg-[#F1F2F6] border border-[#1E73BE] min-w-[6.25rem] min-h-[2.5rem] py-[.25rem] px-[1rem] rounded-[.25rem] "
                >
                  <button  className="flex items-center gap-2 text-[#0E0E0E] font-[400] text-[1rem] font-appleAlt">
                    Action <img src={svg1} alt="svg1" />
                  </button>
                </Dropdown>
 
            </div>
          </div>
        </div>

        <Form form={form} component={false} className="flex-1">
       <Table
    className="editable_table text-xs [&_.ant-table-cell]:whitespace-nowrap [&_.ant-table-cell]:px-2 [&_.ant-table-cell]:py-1"
    scroll={{
      x: "max-content",
      y: "calc(65vh - 90px)",
    }}
    loading={loading}
    size="large"
    bordered={false}
    rowSelection={false}
    columns={[
      ...mergedColumns,
      {
        title: "Action",
        dataIndex: "action",
        width: 150,
        // fixed: "right", // Makes action column sticky on the right
        render: (_, record) => {
          const editable = isEditing(record);
          return editable ? (
            <div className="flex w-fit items-center gap-[1rem]">
              <button
                onClick={cancel}
                className="modal_btn_light"
                type="button"
              >
                Cancel
              </button>
              <button
                type="button"
                onClick={() => saveFunction(record?.tdId)}
                className="modal_btn_dark"
              >
                Save
              </button>
            </div>
          ) : (
            record?.ppIseditable && (
              <div className="flex items-center gap-3">
                {user?.hideEdits ? (
                  <>
                    {isRowLoading(record) ? (
                      <Spin className="sms-spin" />
                    ) : (
                      <Tooltip placement="top" title={"Download Excel"}>
                        <img
                          src={svg20}
                          alt="svg20"
                          className="cursor-pointer"
                          onClick={() => {
                            if (!downloadLoading)
                              handleDownload(record);
                          }}
                        />
                      </Tooltip>
                    )}
                  </>
                ) : (
                  <>
                    <img
                      src={svg10}
                      alt="svg10"
                      className="cursor-pointer"
                      onClick={() => edit(record)}
                    />

                    {isRowLoading(record) ? (
                      <Spin className="sms-spin" />
                    ) : (
                      <Tooltip placement="top" title={"Download Excel"}>
                        <img
                          src={svg20}
                          alt="svg20"
                          className="cursor-pointer"
                          onClick={() => {
                            if (!downloadLoading)
                              handleDownload(record);
                          }}
                        />
                      </Tooltip>
                    )}
                    <Tooltip placement="top" title={"Upload File"}>
                      <img
                        src={svg21}
                        alt="svg21"
                        className="cursor-pointer"
                        onClick={() => handleOpenDocAdd(record)}
                      />
                    </Tooltip>
                  </>
                )}
              </div>
            )
          );
        },
      },
    ]}
    components={{
      body: { cell: EditableCell },
    }}
    dataSource={dataSource}
    rowKey="tdId"
    pagination={false}
    sticky
    rowClassName={(record) =>
      record?.ppColCustomType === "BOLD_BLUE"
        ? "bold-blue-row"
        : record?.ppColCustomType === "bold"
        ? "bold-blue-row-2"
        : "ident-row"
    }
  />
        </Form>
      </div>
      <ConfirmModal
        open={open}
        handleCancel={handleCancel}
        handleSubmit={handleUpdate}
        loading={saving}
        content={`Are you sure you want to submit this record`}
        type="alert"
        btnTitle="Confirm"
      />

      <ConfirmModal
        open={openFill}
        handleCancel={handleCancelFill}
        handleSubmit={handleFill}
        loading={saving}
        content={`Are you sure you want to format and refill from database !`}
        type="alert"
        btnTitle="Confirm"
      />

      <DocumentTableAdd
        isModalOpen={openDocAdd}
        handleCancel={handleCancelDocAdd}
        prodd={prodd}
      />
    </>
  );
}
